import Highway from '@dogstudio/highway';
import { animateIn } from '../animations/contact';

class Contact extends Highway.Renderer {

  onEnterCompleted() {
    animateIn.init();
  }

}

export default Contact;
